export default {
  paymentInfoSection: {
    title: 'Payment Details',
    subTitle: 'Payment outline for this request',
    subSections: {
      payment: {
        title: 'Payment information',
        paymentMethod: {
          label: 'Method',
          placeholder: 'Payment method',
        },
        dueDate: {
          label: 'Due date',
          placeholder: 'Due date',
        },
        assignee: {
          label: 'Assigned to',
          placeholder: 'Assignee',
          empty: 'No users with a role that can be assigned a payment.',
        },
      },
      vendor: {
        title: 'Vendor payment details',
        nameLabel: 'Vendor name',
        salesEmailLabel: 'Sales email',
        paymentsEmailLabel: 'Payments email',
        bankAccHolderLabel: 'Bank acc holder',
        bankAccNumberLabel: 'Bank acc number',
        branchCodeLabel: 'Branch code',
      },
      approval: {
        title: 'Approval history',
        paymentHistoryTitle: 'Payment history',
        approvalLabel1: 'Payment approval 1',
        approvalLabel2: 'Payment approval 2',
        approvalPlaceholder: 'Second approval pending',
        approvedBy: 'Approved by',
        verifiedByLabel: 'Verified by',
        approvedByLabel: 'Approved by',
        cancelledByLabel: 'Cancelled by',
      },
    },
    insufficientVendorFunds:
      'Your vendor account does not have sufficient funds to cover this payment request',
    noSiteFO:
      'No Site Finance Officer is assigned to {siteName} site. This Payment Request cannot progress to verification until one is assigned.',
  },
  adjustmentInformation: {
    title: 'Adjustment Information',
    description: 'Adjustment Description',
  },
  paymentSummarySection: {
    title: 'Payment Information',
    subTitle: 'Payment breakdown, Credit notes',
  },
  orderSummarySection: {
    title: 'Order Summary',
    subTitle: 'Order details related to this request',
  },
  dialogs: {
    confirmTitlePaymentDate: 'Change payment date',
    confirmTitlePaymentDateBody: `This payment request is on account with the vendor. Are you sure you want to proceed?`,
    confirmTitlePaymentMethod: 'Switch payment type',
    confirmTitlePaymentMethodBody: `Changing to the account payment method will adjust the due date for this payment request to the payment period established for this vendor. Are you sure?`,
    vendorLabel: 'Vendor:',
    accountPeriodLabel: 'Account type:',
    oldDataMethodRequired: {
      title: 'Payment method required',
      methodRequired:
        'The payment method needs to be set before a due date or assignee can be added.',
      methodRequiredAction: 'Please select a method that is set on this vendor',
      accountMethodSelectWarn:
        'Selecting the account payment method will adjust the due date for this payment request according to the payment period for this vendor. This can be updated later.',
    },
  },
  severityMessages: {
    accountDateUpdate: `It is recommended to have the vendor's confirmation for any date that differs from their standard terms.`,
    codToAccount: `Confirming this action will change the orders payment method to Account`,
  },
};
